import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const KEY = "gh_intro_seen";
const seen = typeof window !== "undefined" && sessionStorage.getItem(KEY) === "1";
export const INTRO_DELAY = seen ? 0 : 1.5;

export const Intro = () => {
  const [show, setShow] = useState(!seen);
  useEffect(() => {
    if (!show) return undefined;
    sessionStorage.setItem(KEY, "1");
    const t = setTimeout(() => setShow(false), 1500);
    return () => clearTimeout(t);
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="fixed inset-0 z-[100] grid place-items-center bg-white"
          exit={{ y: "-100%" }}
          transition={{ duration: 0.7, ease: [0.76, 0, 0.24, 1] }}
          onClick={() => setShow(false)}
          data-testid="logo-intro"
        >
          <div className="relative w-64 sm:w-80">
            <img src="/logo-dark.png" alt="" className="w-full opacity-10" />
            <motion.img
              src="/logo-dark.png"
              alt="Good Home Improvement LLC"
              className="absolute inset-0 w-full"
              initial={{ clipPath: "inset(100% 0 0 0)" }}
              animate={{ clipPath: "inset(0% 0 0 0)" }}
              transition={{ duration: 1, ease: [0.65, 0, 0.35, 1] }}
            />
            <motion.span
              className="absolute -bottom-6 left-0 h-[3px] bg-slate-900"
              initial={{ width: "0%" }}
              animate={{ width: "100%" }}
              transition={{ duration: 1.1, ease: [0.65, 0, 0.35, 1] }}
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
